export default shuffler(Math.random);
export function shuffler(random) {
    return function shuffle(array, i0, i1) {
        if (i0 === void 0) { i0 = 0; }
        if (i1 === void 0) { i1 = array.length; }
        var m = i1 - (i0 = +i0);
        while (m) {
            var i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}
